import { Button } from '@deliveryhero/pd-cookbook/components/ButtonV2';
import IcEmail from '@deliveryhero/pd-cookbook/components/Icons/IcEmail';
import IcProfile from '@deliveryhero/pd-cookbook/components/Icons/IcProfile';
import Typography from '@deliveryhero/pd-cookbook/components/Typography';

import { Card } from 'src/components/Card';

import { LabelText } from '../constants';
import { GiftCardRecipientsProps } from './types';

import './styles.scss';

export const GiftCardRecipients = ({
  recipients,
  num_of_recipients,
  is_distribute_myself,
  is_csv_recipients,
  handleDownloadRecipientCsv
}: GiftCardRecipientsProps) => {
  let recipientList = <></>;

  if (is_csv_recipients) {
    const recipientCountLabel = `${num_of_recipients} ${
      num_of_recipients === 1
        ? LabelText.GIFT_CARD_RECIPIENTS.USER_COUNT_SINGLE_LABEL
        : LabelText.GIFT_CARD_RECIPIENTS.USER_COUNT_MULTIPLE_LABEL
    }`;

    recipientList = (
      <div className="csv-recipient-count-container">
        <IcProfile fill="neutral-secondary" />
        <Typography type="paragraph-sm">{recipientCountLabel}</Typography>
        <div className="csv-recipient-count-container__cta">
          <Button
            variant="secondary"
            onClick={handleDownloadRecipientCsv}
            size="small"
          >
            {LabelText.GIFT_CARD_RECIPIENTS.DOWNLOAD_CSV_CTA}
          </Button>
        </div>
      </div>
    );
  } else if (recipients) {
    recipientList = (
      <div className="email-recipient-list-container">
        <IcEmail fill="neutral-secondary" />
        <div className="email-recipient-list-container__email-list">
          {recipients.map((recipient, idx) => (
            <div key={idx} data-testid="gift-card-recipients">
              <Typography type="label-md" as="div">
                {recipient.name +
                  (is_distribute_myself
                    ? ` ${LabelText.GIFT_CARD_RECIPIENTS.ADMIN_EMAIL_SUFFIX}`
                    : '')}
              </Typography>
              <Typography type="paragraph-sm" as="div">
                {recipient.email}
              </Typography>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <Card>
      <Typography type="title-md">
        {LabelText.GIFT_CARD_RECIPIENTS.TITLE}
      </Typography>
      {recipientList}
    </Card>
  );
};
